// extracted by mini-css-extract-plugin
export var link = "styles-module--link--VqPvK";
export var rounded = "styles-module--rounded--ZCX1r";
export var text = "styles-module--text--bfUDP";